<ng-container *ifScreenSize="screenSize.Mobile">
  <!--Mobile Nav-->
  <fgb-page-header [pageTitle]="'wallet.page.title'" [showBalance]="false" [showBanner]="false"></fgb-page-header>
</ng-container>

<div class="container">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="d-none d-lg-block py-3">
      <div class="rewards-back-button bg-glass-dark cursor-pointer" (click)="location.back()">
        <span class="material-icons align-middle text-white">arrow_back_ios_new</span>
      </div>
    </div>
  </ng-container>

  <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
</div>
